module.exports = __webpack_public_path__ + "img/7.3214a073.png";